import React, { Component } from 'react'
//import logo from "../levalogo.png";
import axios from "axios";
import NavFormProfile from './NavFormProfile';
import Path from "./config";
import imgcontact from "../unknown.png";
import { Link } from "react-router-dom";
import demoImg1 from "../demoImg.jpg";
import { ProgressBar } from "react-bootstrap"
export class UploadDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      sbg_photo: 'demoImg1',
      typee: 'photo',
      sbg_biodata: '',
      sbg_goverment_document: '',
      isNextBtn: false,
      progress: '',
      progress1: '',
      progress2: '',



    }
  }
  onChangeHandler = event => {
    // Update the state
    this.setState({
      selectedFile: event.target.files[0],
      loaded: 0,
    }

    );

  }
  componentDidMount() {
    this.setState({
      userId: localStorage.getItem("userId")
    })

    this.showImage();


  }

  //  resizeImageFn=(file) =>{

  //   const resizedImage = compress.compress([file], {
  //     size: 2, // the max size in MB, defaults to 2MB
  //     quality: 1, // the quality of the image, max is 1,
  //     maxWidth: 300, // the max width of the output image, defaults to 1920px
  //     maxHeight: 300, // the max height of the output image, defaults to 1920px
  //     resize: true // defaults to true, set false if you do not want to resize the image width and height
  //   })
  //   const img = resizedImage[0];
  //   const base64str = img.data
  //   const imgExt = img.ext
  //   const resizedFiile = Compress.convertBase64ToFile(base64str, imgExt)
  //   return resizedFiile;
  // }
  showImage = () => {
    axios.get(Path + 'Suchi_bride_groom_photoshow.php?sbg_id=' + localStorage.getItem("userId"))
      .then(function (response) {
        // handle success
        //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
        //   data=response.data;
        response = response.data;
        let path = "";
        if (response.sbg_photo === "") {
          path = imgcontact;
        } else {
          path = Path + "" + response.sbg_photo;
        }

        let path1 = "";
        if (response.sbg_biodata === "") {
          path1 = imgcontact;
        } else {
          path1 = Path + "" + response.sbg_biodata;
        }
        let path2 = "";
        if (response.sbg_goverment_document === "") {
          path2 = imgcontact;
        } else {
          path2 = Path + "" + response.sbg_goverment_document;
        }
        if (response.sbg_photo !== "" && response.sbg_goverment_document !== "") {
          this.setState({ isNextBtn: true })
        }

        this.setState({
          sbg_photo: path,
          sbg_biodata: path1,
          sbg_goverment_document: path2
        })
      }.bind(this))
  }
  submitClick = (e) => {
    e.preventDefault();
    let typee = "photo";
    const formData = new FormData();

    if (this.state.selectedFile) {
      formData.append(
        "p_report",
        this.state.selectedFile,
        this.state.selectedFile.name
      );


      formData.append("sbg_id", this.state.userId);
      formData.append("type", typee);
      // const config = {     
      //   headers: { 'content-type': 'multipart/form-data' }
      // }

      // const config1 = {
      //   onUploadProgress: (progressEvent) => {
      //     let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //     this.setState({ progress });
      //   }
      // };
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      // axios.post(Path+`Suchi_Bride_Groom_update.php`,formData,config)
      // .then(res =>  this.showImage(),
      // this.clearAll() ) ; 

      axios.post(Path + `Suchi_Bride_Groom_update.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: data => {
          //Set the progress value to show the progress bar
          this.setState({
            progress: Math.round((100 * data.loaded) / data.total)
          })
          // setProgress(Math.round((100 * data.loaded) / data.total))
        },
      }).then(res => this.showImage(),
        this.clearAll(),
        this.setState({

        }));



      document.getElementById("photo").innerHTML = "";
    }
    else {
      document.getElementById("photo").innerHTML = "Please Select Photo ";
    }

  }

  submitbiodataClick = (e) => {
    e.preventDefault();
    let typee = "biodata";
    const formData = new FormData();

    // console.log("file name",this.state.selectedFile)

    if (this.state.selectedFile) {
      formData.append(
        "p_report",
        this.state.selectedFile,
        this.state.selectedFile.name
      );
      formData.append("sbg_id", this.state.userId);
      formData.append("type", typee);
      // const config = {     
      //   headers: { 'content-type': 'multipart/form-data' }
      // }
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      axios.post(Path + `Suchi_Bride_Groom_update.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: data => {
          //Set the progress value to show the progress bar
          this.setState({
            progress2: Math.round((100 * data.loaded) / data.total)
          })
          // setProgress(Math.round((100 * data.loaded) / data.total))
        },
      }).then(res => this.showImage(),
        this.clearAll());
      document.getElementById("biodata").innerHTML = "";
    }
    else {
      document.getElementById("biodata").innerHTML = "Please Select Biodata ";
    }

  }

  submitdocClick = (e) => {
    e.preventDefault();
    let typee = "document";
    const formData = new FormData();
    // console.log("file name",this.state.selectedFile)
    if (this.state.selectedFile) {

      formData.append(
        "p_report",
        this.state.selectedFile,
        this.state.selectedFile.name
      );
      formData.append("sbg_id", this.state.userId);
      formData.append("type", typee);
      // const config = {     
      //   headers: { 'content-type': 'multipart/form-data' }
      // }
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      axios.post(Path + `Suchi_Bride_Groom_update.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: data => {
          //Set the progress value to show the progress bar
          this.setState({
            progress1: Math.round((100 * data.loaded) / data.total)
          })
          // setProgress(Math.round((100 * data.loaded) / data.total))
        },
      }).then(res => this.showImage(),
        this.clearAll());
      document.getElementById("doc").innerHTML = "";
    }
    else {
      document.getElementById("doc").innerHTML = "Please Select Document ";
    }
  }

  goToNext = (e) => {
    //alert("Updated Successfully");
    let typee = "updocnext";
    let tempStr = "&sbg_id=" + this.state.userId +
      "&type=" + typee
    axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
      .then(function (response) {
        if (response.data.status === "updated") {
          this.props.history.push(`/FormProfile/PostAddress`);
        }
        //alert("Updated Successfully");
      }.bind(this))

  }
  clearAll = () => {
    this.setState({
      selectedFile: "",
      progress: '',
      progress1: '',
      progress2: ''
    })

  }


  render() {



    return (

      <>
        <NavFormProfile />
        <div className="m-2 pt-3"  >

          <span className="pt-3 mb-4 mx-auto text-primary" >
            टीप :आपण अपलोड केलेला फोटो हा सोबत दिलेल्या नमुन्या प्रमाणेच फक्त क्लोज अप आणी योग्य
            क्वालिटी चा असावा फोटो हे या पद्धतीने नसल्यास फोटो सुचित फोटो खराब च प्रिंट होऊ शकतो
            आणी जास्त खराब असलेला फोटो सुचित प्रिंट होणार नाही याची विशेष नोंद घ्यावी. <br></br>
            फोटो ची साईज जास्तीत जास्त 2mb पर्यंत असावी </span>

          <div className="row row-cols-1 row-cols-md-3 g-4 mt-3">
            <div className="col">
              <div className="card ">
                {this.state.loading ?
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  :
                  <div className='text-center'>
                    <img src={this.state.sbg_photo} alt="Leva Shubhmangal" className="card-img-top" style={{ height: "250px", width: "192px" }} />
                  </div>
                }
                <div className="card-body">
                  <h5 className="card-title">* फोटो &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;<Link to={`/FormProfile/PhotoSample`} className="link_class">नमुना फोटो</Link> </h5>
                  <p className="card-text">( प्रत्यकाने फोटो अपलोड करण्या आधी कृपया नमुना फोटो वर क्लिक करा. ) </p>
                  <p> <input type="file" name="file" onChange={this.onChangeHandler} accept="image/*" /></p>
                  <span id="photo" className="text-danger"></span>
                  <button type="submit" className="btn btn-dark" onClick={this.submitClick}>Upload Photo 🔼</button>
                  <br></br><br></br>
                  {this.state.progress && <ProgressBar now={this.state.progress} label={`${this.state.progress}%`} />}

                </div>
              </div>
            </div>

            <div className="col">
              <div className="card">
                <img src={this.state.sbg_goverment_document} alt="Leva Shubhmangal" className="card-img" style={{ height: "250px" }} />
                <div className="card-body">
                  <h5 className="card-title">* शासकीय ओळखपत्र (ID PROOF) </h5>
                  <p>(येथे पॅनकार्ड किंवा ड्राइविंग लायसन्स किंवा वोटर कार्ड इत्यादी टाकावे)</p>
                  <p> <input type="file" onChange={this.onChangeHandler} accept="image/*" /></p>
                  <button type="submit" className="btn btn-dark" onClick={this.submitdocClick} >Upload Identity 🔼</button>
                  <span id="doc" className="text-danger"></span>

                  <br></br><br></br>
                  {this.state.progress1 && <ProgressBar now={this.state.progress1} label={`${this.state.progress1}%`} />}

                </div>
              </div>
            </div>

            <div className="col">
              <div className="card">
                <img src={this.state.sbg_biodata} alt="Leva Shubhmangal" className="card-img" style={{ height: "250px" }} />

                <div className="card-body">
                  <h5 className="card-title">बायोडाटा</h5>
                  <p className="card-text">( आपली भरलेली माहिती एकदा चेक करून घेण्यासाठी बायोडेटा चा फोटो अपलोड करावा )</p>
                  <p> <input type="file" onChange={this.onChangeHandler} /></p>
                  <button type="submit" className="btn btn-dark" onClick={this.submitbiodataClick}>Upload Biodata 🔼</button>
                  <span id="biodata" className="text-danger"></span>
                  <br></br><br></br>
                  {this.state.progress2 && <ProgressBar now={this.state.progress2} label={`${this.state.progress2}%`} />}

                </div>
              </div>
            </div>


          </div>
          {this.state.isNextBtn ?
            <div className=" col-md-8 d-flex  justify-content-center m-5">
              <button type="button" className="btn btn-success btn-lg" onClick={() => this.goToNext()} >Next ▶️</button>
            </div>
            : null}
        </div>

      </>
    )
  }
}

export default UploadDoc